import * as React from "react";

import { BrandTileProps } from "./BrandTileProps";
import { LeanBrandTileRendererBase } from "./LeanBrandTileRendererBase";

export const LeanBrandTileRendererForMarketList: React.FC<BrandTileProps> = (
  props
) => {
  // Setting has_new_products to false to hide "New Items!" text under brand tile
  // Create a new object instead of mutating props
  const brandTileWithoutNewProducts = React.useMemo(() => {
    return props.brandTile
      ? {
          ...props.brandTile,
          brand: props.brandTile.brand
            ? {
                ...props.brandTile.brand,
                has_new_products: false,
              }
            : undefined,
        }
      : undefined;
  }, [props.brandTile]);

  return (
    <LeanBrandTileRendererBase
      {...props}
      brandTile={brandTileWithoutNewProducts}
      withoutFavourite
    />
  );
};
